/* global showInfoToast */
import React, { useState, useEffect } from "react";
import FooterBar from "./layout/FooterBar";
import FooterButton from "./tools/FooterButton";

const Home = () => {
    return (
        <div className="container-fluid">
            Clicca sul menu applicazioni!
            <FooterBar
                footerIcon={"home"}
                footerTitle={`Home`}
                footerButton={
                    <FooterButton icon="add" title="Pulsante" action={() => showInfoToast("Questo è un esempio")} />
                }
            />
        </div>
    );
};
export default Home;